export default __webpack_public_path__ + "static/media/service-qr-code.3ff3d3cf.svg";